<template>
  <div class="">

      <div class="contingut bg-darkBlue row g-0">
          <div class="col-12 mt-4 mb-3 mb-lg-2">
              <h2 class="text-turquesa">{{ $t('cooperacion.title') }}</h2>
          </div>
      </div>

      <div class="contingut bg-white row g-0">
          <div class="row">
              <div class="col pt-0 pt-lg-5 mt-2 mt-lg-5">
                  <img :src="`${publicPath}img/02water2.jpg`" class="img-responsive mb-5" data-aos="fade" data-aos-easing="linear" data-aos-duration="1000">
                  <h3 class="text-blau2" data-aos="fade" data-aos-duration="1000">{{ $t('cooperacion.comprometidos') }}</h3>
                      <h4 class=" text-turquesa p-1 pt-3 pb-5 p-lg-5 pt-lg-3  mx-0 mx-md-5">{{ $t('cooperacion.ayuda') }}</h4>
              </div>
          </div>
      </div>

      <div class="contingut bg-darkBlue  row g-0">
          <div class="col-12 my-4 py-4 bg-darkBlue">
              <h3 class="text-turquesa">{{ $t('cooperacion.proyectos_de') }}</h3>
              <div class="row">
                  <div class="row align-items-top pt-5" data-aos="fade" data-aos-easing="linear" data-aos-duration="10" data-aos-id="start-counter-proyectos">
                      <div class="col-12 col-md-4">
                          <p class="numbersProyectos text-white">
                            <AnimatedNumber
                              ref='counter_coop'
                              :startAmount='0'
                              :endAmount='80'
                              :duration='3'
                              prefix=''
                              suffix=''
                              :separator=separator
                              decimalSeparator=','
                              :decimals='0'
                              :autoinit='true'
                          />
                          </p>
                          <p class="numbersPeu text-white">{{ $t('cooperacion.proyectos') }}</p>
                      </div>
                      <div class="col-12 col-md-4">
                          <p class="numbersProyectos text-white"><AnimatedNumber
                              ref='counter_proyectos'
                              :startAmount='0'
                              :endAmount='29'
                              :duration='3'
                              prefix=''
                              suffix=''
                              separator='.'
                              decimalSeparator=','
                              :decimals='0'
                              :autoinit='true'
                          /></p>
                          <p class="numbersPeu text-white">{{ $t('cooperacion.paises') }}</p>
                      </div>
                      <div class="col-12 col-md-4">
                          <p class="numbersProyectos text-white"><AnimatedNumber
                              ref='counter_paises'
                              :startAmount='0'
                              :endAmount='2.2'
                              :duration='3'
                              prefix=''
                              suffix='M'
                              separator='.'
                              :decimalSeparator=decimal_separator
                              :decimals='1'
                              :autoinit='true'
                          /></p>
                          <p class="numbersPeu text-white">{{ $t('cooperacion.beneficiadas') }}</p>
                      </div>
                  </div>
              </div>
              <div class="row">
                  <div class="row justify-content-center pt-5">
                      <h3 class="text-turquesa">{{ $t('cooperacion.colaboracion') }}</h3>
                      <div class="col-12 col-lg-11 m-auto">
                      <p class="text-white p-0 p-md-5 pt-md-2 mx-5">{{ $t('cooperacion.colaboracion_txt') }}</p>
                      </div>
                      <div class="col-12 col-md-3 py-5 py-md-0">
                          <img :src="`${publicPath}img/02waterLogo1.png`" class="img-responsive">
                      </div>
                      <div class="col-12 col-md-3 py-5 py-md-0">
                          <img :src="`${publicPath}img/02waterLogo2.png`" class="img-responsive">
                      </div>
                      <div class="col-12 col-md-3 py-5 py-md-0">
                          <img :src="`${publicPath}img/02waterLogo3.png`" class="img-responsive">
                      </div>
                  </div>
              </div>

          </div>
      </div>


      <div class="contingut bg-white row g-0">
          <div class="row">
              <div class="col p-5 m-0 m-lg-5">
                  <h4 class="text-blau2" data-aos="fade" data-aos-duration="1000">{{ $t('cooperacion.proyectos_txt') }}</h4>
              </div>
          </div>

          <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel" data-bs-wrap="false">
              <div class="carousel-inner">
                  <div class="carousel-item active">
                      <div class="row justify-content-center pb-0 pb-lg-5 mb-0 mb-lg-5">
                          <div class="col-12 col-md-6 col-lg-5 p-3 text-center text-lg-start">
                              <img :src="`${publicPath}img/02waterZonas.jpg`" class="img-responsive mb-4" data-aos="fade" data-aos-easing="linear"  data-aos-duration="1000">
                              <h3 class="text-turquesa mb-3">{{ $t('cooperacion.zonas') }}</h3>
                              <hr>
                              <p v-html="$t('cooperacion.zonas_txt')"></p>
                          </div>
                          <div class="col-12 col-md-6 col-lg-5 p-3 text-center text-lg-start">
                              <img :src="`${publicPath}img/02waterComunidades.jpg`" class="img-responsive mb-4" data-aos="fade" data-aos-easing="linear"  data-aos-duration="1000">
                              <h3 class="text-turquesa mb-3">{{ $t('cooperacion.comunidades') }}</h3>
                              <hr>
                              <p v-html="$t('cooperacion.comunidades_txt')"></p>
                          </div>
                      </div>
                  </div>
                  <div class="carousel-item">
                      <div class="row justify-content-center pb-0 pb-lg-5 mb-0 mb-lg-5">
                          <div class="col-12 col-md-6 col-lg-5 p-3 text-center text-lg-start">
                              <img :src="`${publicPath}img/02waterEscuelas.jpg`" class="img-responsive mb-4" data-aos="fade" data-aos-easing="linear" data-aos-delay="100" data-aos-duration="1000">
                              <h3 class="text-turquesa mb-3">{{ $t('cooperacion.escuelas') }}</h3>
                              <hr>
                              <p v-html="$t('cooperacion.escueltas_txt')"></p>
                          </div>
                          <div class="col-12 col-md-6 col-lg-5 p-3 text-center text-lg-start">
                              <img :src="`${publicPath}img/02waterCentros.jpg`" class="img-responsive mb-4" data-aos="fade" data-aos-easing="linear" data-aos-delay="200" data-aos-duration="1000">
                              <h3 class="text-turquesa mb-3">{{ $t('cooperacion.centros') }}</h3>
                              <hr>
                              <p v-html="$t('cooperacion.centros_txt')"></p>
                          </div>
                      </div>
                  </div>
              </div>
              <button class="carousel-control-prev d-none d-md-block" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                  <img :src="`${publicPath}img/carouselBack.png`" class="img-responsive">
                  <span class="visually-hidden">Previous</span>
              </button>
              <button class="carousel-control-next d-none d-md-block" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                  <img :src="`${publicPath}img/carouselNext.png`" class="img-responsive">
                  <span class="visually-hidden">Next</span>
              </button>
          </div>
          <hr>
          <div class="row p-0 g-0">
              <div class="col-6 p-3 p-lg-0 m-0 pb-3 pb-lg-5 text-start">
                  <localized-link class="footerLink" to="/fundacion-we-are-water"><img :src="`${publicPath}img/breadcrumbBack.gif`" class="img-responsive" width="6"> {{ $t("nav.we-are-water") }}</localized-link>
              </div>
              <div class="col-6 p-3 p-lg-0 m-0 pb-3 pb-lg-5 text-end">
                  <localized-link class="footerLink" to="/fundacion-we-are-water/acciones-de-concienciacion">{{ $t("nav.acciones-de-concienciacion") }} <img :src="`${publicPath}img/breadcrumbGo.gif`" class="img-responsive" width="6"></localized-link>
              </div>
          </div>
      </div>

  </div>
</template>


<script>
import AnimatedNumber from 'vue3-autocounter'

  export default {
    components: {
      AnimatedNumber
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            separator: '.',
            decimal_separator: ','

        }
    },
    mounted() {
      document.addEventListener('aos:in:start-counter-proyectos', this.startCounter);
      if(this.$i18n.locale=="es"){
        this.separator = '.';
        this.decimal_separator = ',';
      } else {
        this.separator = ',';
        this.decimal_separator = '.';
      }
    },
    methods: {
      startCounter() {
        if (this.$refs.counter_coop != null) {
          this.$refs.counter_coop.start();
        }
        if (this.$refs.counter_proyectos != null) {
          this.$refs.counter_proyectos.start();
        }
        if (this.$refs.counter_paises != null) {
          this.$refs.counter_paises.start();
        }
      },
    }
  }
</script>
